export default __webpack_public_path__ + "static/media/Hubano-1Open.a06bc3cc.jpg";